import React, { useState } from 'react';
import I18n from 'i18n-js';
import Text from '@/components/ui/Text';
import Icon from '@/components/ui/Icon';
import cn from '@/utils/cn';
import useFlags from '@/hooks/useFlags';
import * as Routes from '@/modules/routes';

// AIDEV-NOTE: Visibility is gated by the gulf_of_america_messaging_enabled LaunchDarkly flag
// (checked in initializer.ts). If a user is flagged, the banner always shows regardless of
// page content. Dismissal is persisted server-side as a date string (YYYY-MM-DD) on the user's
// flags JSON column and expires at end of calendar day — the banner reappears the next day.
const GulfOfMexicoNotice = () => {
  const { gulfOfMexicoNoticeDismissed } = useFlags();
  const [dismissed, setDismissed] = useState(!!gulfOfMexicoNoticeDismissed);

  const handleDismiss = () => {
    setDismissed(true);
    navigator.sendBeacon(Routes.plato_api_dismiss_gulf_of_mexico_notice_settings_path());
  };

  if (dismissed) return null;

  return (
    <div
      aria-live="polite"
      // AIDEV-NOTE: #effbff has no design token — one-off notice background color from Figma
      className={cn(
        'tw-relative tw-flex tw-items-center tw-justify-center tw-w-full tw-box-border',
        'tw-pl-6 tw-pr-12 tw-py-1.5 tw-min-h-9',
        'tw-bg-[#effbff] tw-border-t tw-border-solid tw-border-teal-blue',
      )}
      data-testid="gulf-of-mexico-notice"
      role="status"
    >
      <span
        aria-hidden="true"
        className="tw-text-teal-blue tw-mr-2 tw-text-sm tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center"
      >
        <Icon icon="InfoAlternate" />
      </span>
      <Text
        className="tw-text-tci-black"
        size="sm"
        tag="span"
        variant="body"
        weight="bold"
      >
        {I18n.t('gulf_of_mexico_notice.message')}
      </Text>
      <button
        aria-label={I18n.t('gulf_of_mexico_notice.close')}
        className={cn(
          'tw-absolute tw-right-4 tw-top-1/2 -tw-translate-y-1/2 tw-flex-shrink-0',
          'tw-bg-transparent tw-border-none tw-cursor-pointer tw-p-1 tw-text-tci-black',
        )}
        type="button"
        onClick={handleDismiss}
      >
        &#10005;
      </button>
    </div>
  );
};

export default GulfOfMexicoNotice;
